export default __webpack_public_path__ + "static/media/1051.c1c6c0e1.png";